// Constantes centralizadas para nomes de módulos
// Organizadas seguindo a estrutura exata do sidebar

export const MODULE_NAMES = {
  // === MÓDULOS PRINCIPAIS (conforme sidebar) ===
  
  // 1. Página Inicial
  HOME: 'Página Inicial',
  
  // 2. Assinaturas (módulo principal)
  SUBSCRIPTIONS: 'Assinaturas',
  
  // 3. Formações (módulo principal) 
  FORMATIONS: 'Formações',
  
  // 4. Vendas (módulo principal)
  SALES: 'Vendas',
  
  // 5. E-Commerce (módulo principal)
  ECOMMERCE: 'E-Commerce',
  
  // 6. Configurações (módulo principal + páginas não listadas)
  SETTINGS: 'Configurações',
  
  // === SUBMÓDULOS POR CATEGORIA ===
  
  // Submódulos de Assinaturas
  SUBSCRIPTIONS_LIST: 'Lista de Assinaturas',
  CUSTOMERS: 'Clientes',
  INVOICES: 'Faturas',
  
  // Submódulos de Formações
  CLASSES: 'Classes',
  SESSIONS_CALENDAR: 'Calendário de Sessões',
  COURSES: 'Cursos',
  
  // Submódulos de Vendas
  BUSINESS_OPPORTUNITIES: 'Oportunidades',
  
  // Submódulos de E-Commerce
  TRANSACTIONS: 'Transações',
  VOUCHERS: 'Vouchers',
  
  // === PÁGINAS DE CONFIGURAÇÕES ===
  // (Inclui todas as páginas não listadas no sidebar)
  
  // Gestão de Usuários e Acesso
  USERS: 'Usuários',
  ACCESS_CONTROL: 'Controle de Acesso',
  PROFILE: 'Perfil',
  
  // Integrações e Sistema
  INTEGRATIONS: 'Integrações',
  SYSTEM_JOBS: 'System Jobs',
  SYSTEM_NOTIFICATIONS: 'Notificações do Sistema',
  
  // Planos e Assinaturas (configuração)
  SUBSCRIPTION_PLANS: 'Planos de Assinatura',
  SUBSCRIPTION_PLAN_FAMILIES: 'Famílias de Planos',
  ECONOMIC_INDICES: 'Índices Econômicos',
  
  // Gestão de Conteúdo
  COURSE_FAMILIES: 'Famílias de Cursos',
  INSTRUCTORS: 'Instrutores',
  
  // Documentos e Templates
  CONTRACTS: 'Contratos',
  CONTRACT_TEMPLATES: 'Templates de Contrato',
  PROPOSAL_TEMPLATES: 'Templates de Proposta',
  
  // E-mails e Comunicação
  TRANSACTIONAL_EMAILS: 'Emails Transacionais',
  EMAIL_TEMPLATES: 'Templates de Email',
  
  // Customer Success
  PLAYBOOKS: 'Playbooks',
  PLAYBOOK_RUNS: 'Execuções de Playbooks',
  
  // Suporte
  SUPPORT_INBOX: 'Caixa de Entrada',
  SUPPORT_TICKETS: 'Tickets de Suporte',
  
  // Páginas de Detalhes (configuração)
  CUSTOMER_DETAIL: 'Detalhes do Cliente',
  SUBSCRIPTION_DETAIL: 'Detalhes da Assinatura',
  CLASS_DETAIL: 'Detalhes da Classe',
  COURSE_DETAIL: 'Detalhes do Curso',
  INSTRUCTOR_DETAIL: 'Detalhes do Instrutor',
  TRANSACTION_DETAIL: 'Detalhes da Transação',
  INVOICE_DETAIL: 'Detalhes da Fatura',
  BUSINESS_OPPORTUNITY_DETAIL: 'Detalhes da Oportunidade',
  CONTRACT_DETAIL: 'Detalhes do Contrato',
  PROPOSAL_DETAIL: 'Detalhes da Proposta',
  PLAYBOOK_DETAIL: 'Detalhes do Playbook',
  
  // Páginas de Formulários (configuração)
  BUSINESS_OPPORTUNITY_FORM: 'Formulário de Oportunidade',
  CONTRACT_TEMPLATE_FORM: 'Formulário de Template de Contrato',
  PROPOSAL_TEMPLATE_FORM: 'Formulário de Template de Proposta',
  COURSE_FORM: 'Formulário de Curso',
  VENDOR_FORM: 'Formulário de Fornecedor',
  
  // Wizards e Assistentes (configuração)
  SUBSCRIPTION_WIZARD: 'Assistente de Assinatura',
  CLASS_WIZARD: 'Assistente de Classe',
  OPPORTUNITY_WIZARD: 'Assistente de Oportunidade',
  
  // Dashboards Específicos (configuração)
  UNIFIED_DASHBOARD: 'Dashboard Unificado',
  CLASSES_DASHBOARD: 'Dashboard de Classes',
  INVOICES_DASHBOARD: 'Dashboard de Faturas',
  
  // Outras Páginas (configuração)
  VOUCHER_CODES: 'Códigos de Voucher',
  VENDORS: 'Fornecedores',
  SYSTEM_ORDERS: 'Pedidos do Sistema',
  TASK_MANAGEMENT: 'Gerenciamento de Tarefas',
  IMPORT_SUBSCRIPTION_PLANS: 'Importar Planos de Assinatura',
  
  // Páginas Públicas (configuração)
  PUBLIC_PROPOSAL_VIEW: 'Visualização Pública de Proposta',
  PLAYBOOK_PUBLIC_VIEW: 'Visualização Pública de Playbook',
  
  // Páginas de Erro e Utilitárias (configuração)
  NOT_FOUND: 'Página Não Encontrada',
  UNAUTHORIZED: 'Não Autorizado',
  LOADING_EXAMPLES: 'Exemplos de Loading',
} as const;

// Estrutura hierárquica dos módulos (conforme sidebar)
export const MODULE_HIERARCHY = {
  // Módulos principais com seus submódulos
  [MODULE_NAMES.HOME]: {
    routes: ['/'],
    submenu: []
  },
  
  [MODULE_NAMES.SUBSCRIPTIONS]: {
    routes: ['/subscriptions'],
    submenu: [
      MODULE_NAMES.SUBSCRIPTIONS_LIST,
      MODULE_NAMES.CUSTOMERS,
      MODULE_NAMES.INVOICES
    ]
  },
  
  [MODULE_NAMES.FORMATIONS]: {
    routes: ['/classes'],
    submenu: [
      MODULE_NAMES.CLASSES,
      MODULE_NAMES.SESSIONS_CALENDAR,
      MODULE_NAMES.COURSES
    ]
  },
  
  [MODULE_NAMES.SALES]: {
    routes: ['/business-opportunities'],
    submenu: [
      MODULE_NAMES.BUSINESS_OPPORTUNITIES
    ]
  },
  
  [MODULE_NAMES.ECOMMERCE]: {
    routes: ['/transactions', '/voucher-codes'],
    submenu: [
      MODULE_NAMES.TRANSACTIONS,
      MODULE_NAMES.VOUCHERS
    ]
  },
  
  [MODULE_NAMES.SETTINGS]: {
    routes: ['/settings'],
    submenu: [
      // Todas as páginas não listadas no sidebar vão aqui
      MODULE_NAMES.USERS,
      MODULE_NAMES.ACCESS_CONTROL,
      MODULE_NAMES.PROFILE,
      MODULE_NAMES.INTEGRATIONS,
      MODULE_NAMES.SYSTEM_JOBS,
      MODULE_NAMES.SYSTEM_NOTIFICATIONS,
      MODULE_NAMES.SUBSCRIPTION_PLANS,
      MODULE_NAMES.SUBSCRIPTION_PLAN_FAMILIES,
      MODULE_NAMES.ECONOMIC_INDICES,
      MODULE_NAMES.COURSE_FAMILIES,
      MODULE_NAMES.INSTRUCTORS,
      MODULE_NAMES.CONTRACTS,
      MODULE_NAMES.CONTRACT_TEMPLATES,
      MODULE_NAMES.PROPOSAL_TEMPLATES,
      MODULE_NAMES.TRANSACTIONAL_EMAILS,
      MODULE_NAMES.EMAIL_TEMPLATES,
      MODULE_NAMES.PLAYBOOKS,
      MODULE_NAMES.PLAYBOOK_RUNS,
      MODULE_NAMES.SUPPORT_INBOX,
      MODULE_NAMES.SUPPORT_TICKETS,
      // Páginas de detalhes
      MODULE_NAMES.CUSTOMER_DETAIL,
      MODULE_NAMES.SUBSCRIPTION_DETAIL,
      MODULE_NAMES.CLASS_DETAIL,
      MODULE_NAMES.COURSE_DETAIL,
      MODULE_NAMES.INSTRUCTOR_DETAIL,
      MODULE_NAMES.TRANSACTION_DETAIL,
      MODULE_NAMES.INVOICE_DETAIL,
      MODULE_NAMES.BUSINESS_OPPORTUNITY_DETAIL,
      MODULE_NAMES.CONTRACT_DETAIL,
      MODULE_NAMES.PROPOSAL_DETAIL,
      MODULE_NAMES.PLAYBOOK_DETAIL,
      // Formulários
      MODULE_NAMES.BUSINESS_OPPORTUNITY_FORM,
      MODULE_NAMES.CONTRACT_TEMPLATE_FORM,
      MODULE_NAMES.PROPOSAL_TEMPLATE_FORM,
      MODULE_NAMES.COURSE_FORM,
      MODULE_NAMES.VENDOR_FORM,
      // Wizards
      MODULE_NAMES.SUBSCRIPTION_WIZARD,
      MODULE_NAMES.CLASS_WIZARD,
      MODULE_NAMES.OPPORTUNITY_WIZARD,
      // Dashboards
      MODULE_NAMES.UNIFIED_DASHBOARD,
      MODULE_NAMES.CLASSES_DASHBOARD,
      MODULE_NAMES.INVOICES_DASHBOARD,
      // Outras páginas
      MODULE_NAMES.VOUCHER_CODES,
      MODULE_NAMES.VENDORS,
      MODULE_NAMES.SYSTEM_ORDERS,
      MODULE_NAMES.TASK_MANAGEMENT,
      MODULE_NAMES.IMPORT_SUBSCRIPTION_PLANS,
      MODULE_NAMES.PUBLIC_PROPOSAL_VIEW,
      MODULE_NAMES.PLAYBOOK_PUBLIC_VIEW,
      MODULE_NAMES.NOT_FOUND,
      MODULE_NAMES.UNAUTHORIZED,
      MODULE_NAMES.LOADING_EXAMPLES
    ]
  }
} as const;

// Mapeamento de rotas para nomes de módulos
export const ROUTE_TO_MODULE = {
  // Página inicial
  '/': MODULE_NAMES.HOME,
  
  // Assinaturas e submódulos
  '/subscriptions': MODULE_NAMES.SUBSCRIPTIONS_LIST,
  '/customers': MODULE_NAMES.CUSTOMERS,
  '/invoices': MODULE_NAMES.INVOICES,
  
  // Formações e submódulos
  '/classes': MODULE_NAMES.CLASSES,
  '/sessions-calendar': MODULE_NAMES.SESSIONS_CALENDAR,
  '/courses': MODULE_NAMES.COURSES,
  
  // Vendas e submódulos
  '/business-opportunities': MODULE_NAMES.BUSINESS_OPPORTUNITIES,
  
  // E-Commerce e submódulos
  '/transactions': MODULE_NAMES.TRANSACTIONS,
  '/voucher-codes': MODULE_NAMES.VOUCHERS,
  
  // Configurações (todas as páginas não listadas no sidebar)
  '/settings': MODULE_NAMES.SETTINGS,
  '/users': MODULE_NAMES.USERS,
  '/access-control': MODULE_NAMES.ACCESS_CONTROL,
  '/profile': MODULE_NAMES.PROFILE,
  '/integrations': MODULE_NAMES.INTEGRATIONS,
  '/system-jobs': MODULE_NAMES.SYSTEM_JOBS,
  '/system-notifications': MODULE_NAMES.SYSTEM_NOTIFICATIONS,
  '/subscription-plans': MODULE_NAMES.SUBSCRIPTION_PLANS,
  '/subscription-plan-families': MODULE_NAMES.SUBSCRIPTION_PLAN_FAMILIES,
  '/economic-indices': MODULE_NAMES.ECONOMIC_INDICES,
  '/course-families': MODULE_NAMES.COURSE_FAMILIES,
  '/instructors': MODULE_NAMES.INSTRUCTORS,
  '/contracts': MODULE_NAMES.CONTRACTS,
  '/contract-templates': MODULE_NAMES.CONTRACT_TEMPLATES,
  '/proposal-templates': MODULE_NAMES.PROPOSAL_TEMPLATES,
  '/transactional-emails': MODULE_NAMES.TRANSACTIONAL_EMAILS,
  '/templates-email': MODULE_NAMES.EMAIL_TEMPLATES,
  '/playbooks': MODULE_NAMES.PLAYBOOKS,
  '/playbook-runs': MODULE_NAMES.PLAYBOOK_RUNS,
  '/support/inbox': MODULE_NAMES.SUPPORT_INBOX,
  '/support/tickets': MODULE_NAMES.SUPPORT_TICKETS,
  '/task-management': MODULE_NAMES.TASK_MANAGEMENT,
  '/dashboard': MODULE_NAMES.UNIFIED_DASHBOARD,
  '/vendors': MODULE_NAMES.VENDORS,
  '/system-orders': MODULE_NAMES.SYSTEM_ORDERS,
  '/import-subscription-plans': MODULE_NAMES.IMPORT_SUBSCRIPTION_PLANS,
} as const;

// Ações disponíveis para permissões (sem DELETE)
export const PERMISSION_ACTIONS = {
  VIEW: 'view',
  CREATE: 'create',
  EDIT: 'edit',
} as const;

// Mapeamento de ações para labels em português
export const ACTION_LABELS = {
  [PERMISSION_ACTIONS.VIEW]: 'Visualizar',
  [PERMISSION_ACTIONS.CREATE]: 'Criar',
  [PERMISSION_ACTIONS.EDIT]: 'Editar',
} as const;

// Função utilitária para obter o nome do módulo pela rota
export function getModuleNameByRoute(route: string): string | undefined {
  return ROUTE_TO_MODULE[route as keyof typeof ROUTE_TO_MODULE];
}

// Função utilitária para obter o módulo pai de um submódulo
export function getParentModule(moduleName: string): string | undefined {
  for (const [parent, config] of Object.entries(MODULE_HIERARCHY)) {
    if (config.submenu.includes(moduleName as any)) {
      return parent;
    }
  }
  return undefined;
}

// Função utilitária para verificar se um módulo é principal (tem submódulos)
export function isMainModule(moduleName: string): boolean {
  return Object.keys(MODULE_HIERARCHY).includes(moduleName);
}

// Função utilitária para obter todos os submódulos de um módulo principal
export function getSubmodules(parentModule: string): string[] {
  const config = MODULE_HIERARCHY[parentModule as keyof typeof MODULE_HIERARCHY];
  return config ? config.submenu : [];
}

// Função utilitária para validar se um nome de módulo é válido
export function isValidModuleName(name: string): boolean {
  return Object.values(MODULE_NAMES).includes(name as any);
}

// Lista de módulos principais na ordem do sidebar
export const MAIN_MODULES_ORDER = [
  MODULE_NAMES.HOME,
  MODULE_NAMES.SUBSCRIPTIONS,
  MODULE_NAMES.FORMATIONS,
  MODULE_NAMES.SALES,
  MODULE_NAMES.ECOMMERCE,
  MODULE_NAMES.SETTINGS
] as const;
